import { render, staticRenderFns } from "./joinUsDetail.vue?vue&type=template&id=3fe7daff&scoped=true&"
import script from "./joinUsDetail.vue?vue&type=script&lang=js&"
export * from "./joinUsDetail.vue?vue&type=script&lang=js&"
import style0 from "./joinUsDetail.vue?vue&type=style&index=0&id=3fe7daff&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe7daff",
  null
  
)

export default component.exports